import ActionTypes from '../constants/ActionTypes';

export const progressStart = message => ({
  type: ActionTypes.PROGRESS_START,
  message,
});

export const progressStop = () => ({ type: ActionTypes.PROGRESS_STOP });
